import { app } from '../../../../../app';
import { Controller } from './group-applications.controller';

app.component('companyUserDirectoriesManageGroupApplications', {
    bindings: {
        applications: '<',
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./group-applications.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/group-applications.component.js